export default __webpack_public_path__ + "static/media/jobbie.87a1c3d8.png";